import { ArrowLeft } from 'baseui/icon';
import { useDispatch } from 'react-redux'
import { routeBack } from '../application/actions/ui';
import { useStyletron } from 'baseui';
import { Block } from 'baseui/block';
import ReDoButton from './ReDoButton';


const ReDoBackButton = ({ onClick, className, ...props }) => {
  const dispatch = useDispatch();
  const [css, theme] = useStyletron();

  const onBackClick = () => {
    !onClick ? dispatch(routeBack) : onClick()
  }

  return (
    <Block display='flex'>
      <div className={`${css({ height: '44px', minWidth: '44px', position: 'relative' })} ${className}`}>
        <ReDoButton kind='link' color={theme.colors.black} onClick={onBackClick} overrides={{
          BaseButton: { style: { minHeight: '44px', minWidth: '44px', paddingLeft: '10px', paddingRight: '10px', position: 'absolute', left: '-10px', top: '0', boxShadow: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' } }
        }}>
          <ArrowLeft size={theme.sizing.scale1000} />
        </ReDoButton>
      </div>
    </Block>
  );
};

export default ReDoBackButton;